import SmoothScroll from 'smooth-scroll';

export default function () {
    new SmoothScroll('a[href*="#"]', {
        offset: 120,
    });
}
